import * as React from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

import { cn } from "@/lib/cn";

type JourneyParagraphProps = React.HTMLAttributes<HTMLParagraphElement> & {
  children: React.ReactNode;
};

/**
 * Renders a paragraph with a journey animation
 *
 * @param children - The content of the paragraph
 */
const JourneyParagraph: React.FC<JourneyParagraphProps> = ({
  children,
  ...props
}) => {
  const paragraphRef = React.useRef<HTMLParagraphElement>(null);

  useGSAP(() => {
    gsap.fromTo(
      paragraphRef.current,
      { y: "100%" },
      {
        y: 0,
        duration: 1.75,
        delay: 0.075,
        ease: "power4",
        stagger: 0.01,
        scrollTrigger: {
          trigger: paragraphRef.current,
          start: "top bottom",
          end: "bottom center",
        },
      }
    );
  }, [children]);

  return (
    <div className="overflow-hidden">
      <p
        ref={paragraphRef}
        {...props}
        className={cn("journey-paragraph", props.className)}
      >
        {children}
      </p>
    </div>
  );
};

export default JourneyParagraph;
